import { connect } from 'react-redux';
import partial from 'lodash/partial';
import { bindActionCreators } from 'redux';
import { toggleModal } from 'common/modal/ducks';
import ReservationModal from 'project/components/reservation_modal';
import { isEliteReserved, isEliteWindowOpen, getEliteReservationWindowEnd } from 'project/utils';

export function mapStateToProps(state) {
  return {
    isReserved: isEliteReserved(state),
    isEliteWindowOpen: isEliteWindowOpen(state),
    reservationWindowEnd: getEliteReservationWindowEnd(state)
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    closeModal: partial(toggleModal, 'elite-reservation-modal'),
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(ReservationModal);



// WEBPACK FOOTER //
// ./project/containers/reservation_modal.js